import { produce } from 'immer';
import { ADD_PLAYER_ANIMATION, ADD_TABLE_SHAKE_ANIMATION, CLEAR_ANIMATIONS_STATE, CLEAR_PLAYER_ANIMATIONS, REMOVE_PLAYER_ANIMATION, REMOVE_TABLE_SHAKE_ANIMATION } from '../actions/animationsActions';
import { getIncrementedId } from './utils/reducerUtils';
const initialState = {
    playerAnimations: {},
    nextPlayerAnimationId: 0,
    tableShakeAnimations: [],
    nextTableShakeAnimationId: 0
};
function draftGetAndIncrementPlayerAnimationId(draft) {
    const currId = draft.nextPlayerAnimationId;
    draft.nextPlayerAnimationId = getIncrementedId(draft.nextPlayerAnimationId);
    return currId;
}
function draftGetAndIncrementTableShakeAnimationId(draft) {
    const currTableShakeAnimationId = draft.nextTableShakeAnimationId;
    draft.nextTableShakeAnimationId = getIncrementedId(draft.nextTableShakeAnimationId);
    return currTableShakeAnimationId;
}
const animationsReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case CLEAR_ANIMATIONS_STATE: {
                return initialState;
            }
            case ADD_PLAYER_ANIMATION: {
                const { seatIndex, playerAnimationBase } = action.payload;
                const newPlayerAnimation = {
                    ...playerAnimationBase,
                    id: draftGetAndIncrementPlayerAnimationId(draft),
                    startTimestampMs: performance.now()
                };
                let existingPlayerAnimations = draft.playerAnimations[seatIndex];
                if (!existingPlayerAnimations) {
                    existingPlayerAnimations = [];
                    draft.playerAnimations[seatIndex] = existingPlayerAnimations;
                }
                existingPlayerAnimations.push(newPlayerAnimation);
                break;
            }
            case REMOVE_PLAYER_ANIMATION: {
                const { seatIndex, id } = action.payload;
                const newPlayerAnimations = (draft.playerAnimations[seatIndex] || []).filter((playerAnimation) => playerAnimation.id !== id);
                if (newPlayerAnimations.length) {
                    draft.playerAnimations[seatIndex] = newPlayerAnimations;
                }
                else {
                    delete draft.playerAnimations[seatIndex];
                }
                break;
            }
            case CLEAR_PLAYER_ANIMATIONS: {
                const seatIndex = action.payload;
                delete draft.playerAnimations[seatIndex];
                break;
            }
            case ADD_TABLE_SHAKE_ANIMATION: {
                const id = draftGetAndIncrementTableShakeAnimationId(draft);
                draft.tableShakeAnimations.push({ ...action.payload, id, startTimestampMs: performance.now() });
                break;
            }
            case REMOVE_TABLE_SHAKE_ANIMATION: {
                draft.tableShakeAnimations = draft.tableShakeAnimations.filter(({ id }) => id !== action.payload);
                break;
            }
        }
    });
};
export default animationsReducer;
